'use client';

import type { ReactNode } from 'react';
import { Box, VStack } from '@terra/ui-styled-system';
import { InlineToolExpand } from '../../InlineToolExpand';
import { hasRenderableNode } from '../../chat-renderability';
import type { CardRenderContext } from '../../tool-config-types';
import { renderCodeAnalyzerStreamingContent } from './code-analyzer-streaming-renderer';

export const renderCodeAnalyzerCard = (ctx: CardRenderContext): ReactNode => {
  const isRunning =
    ctx.isGroupRunning ||
    ctx.toolCallData.status === 'started' ||
    ctx.toolCallData.status === 'in-progress';
  const streamingContent = renderCodeAnalyzerStreamingContent({
    toolCallId: ctx.toolCallData.toolCallId ?? ctx.toolCallData.id ?? '',
    progressEvents: ctx.toolCallData.progressEvents,
    isRunning,
  });
  const hasStreamingContent = hasRenderableNode(streamingContent);
  const hasNestedContent = hasRenderableNode(ctx.nestedContent);
  const nestedContent =
    hasStreamingContent || hasNestedContent ? (
      <VStack alignItems="stretch" gap={2} width="100%">
        {hasStreamingContent ? streamingContent : null}
        {hasNestedContent ? <Box width="100%">{ctx.nestedContent}</Box> : null}
      </VStack>
    ) : undefined;
  const displayText = isRunning
    ? (ctx.runningText ?? ctx.labelPresent)
    : ctx.labelPast;
  const expandStatus =
    isRunning && ctx.toolCallData.status !== 'error'
      ? ctx.toolCallData.status === 'started'
        ? 'started'
        : 'in-progress'
      : ctx.toolCallData.status;

  return (
    <InlineToolExpand
      toolName={ctx.toolName}
      displayText={displayText}
      status={expandStatus}
      error={ctx.toolCallData.error}
      defaultExpanded={false}
      forceExpanded={ctx.forceExpanded}
      nestedContent={nestedContent}
      summary={ctx.nestedSummary}
      expansionKey={ctx.expansionKey}
    />
  );
};
